<template>
  <!-- Uncomment this to display the close button of the panel
<button class="kt-header-menu-wrapper-close" id="kt_header_menu_mobile_close_btn">
  <i class="la la-close"></i>
</button>
-->
  <div
    class="kt-header-menu-wrapper"
    id="kt_header_menu_wrapper"
    :style="`${$getContainerOption('header_font_color')} ${$getContainerOption(
      'top_menu_hover_color'
    )}`"
  >
    <div
      id="kt_header_menu"
      class="kt-header-menu kt-header-menu-mobile kt-header-menu--layout-default"
    >
      <ul class="kt-menu__nav">
        <li
          id="browseCourseLink"
          class="kt-menu__item kt-menu__item--submenu kt-menu__item--rel mr-4"
        >
          <v-hover>
            <a
              class="kt-menu__link kt-menu__toggle font-weight-bolder pulsing"
              @click.prevent="goToRef()"
            >
              <span class="kt-menu__link-icon">
                <i
                  style="color: black !important"
                  class="header-icon fad fa-books"
                />
              </span>
              <span class="kt-menu__link-text" style="color: black !important">
                Go To Training
              </span>
            </a>
          </v-hover>
        </li>
        <li class="kt-menu__item kt-menu__item--submenu kt-menu__item--rel">
          <v-hover>
            <router-link
              :to="{
              name: 'Secret Shops'
}"
              class="kt-menu__link kt-menu__toggle"
              slot-scope="{ hover }"
              :style="`${hover ? '' : ''} ${
                activeRoute(
                  '/client/shops'
                )
                  ? 'color: var(--navbar-text-active) !important'
                  : ''
              }`"
            >
              <span class="kt-menu__link-icon kt-svg-icon">
                <i
                  class="header-icon text-slate-900 fal fa-home"
                  :style="`${
                    activeRoute('/client/shops'
                    )
                      ? 'color: var(--navbar-text-active) !important'
                      : ''
                  }`"
                ></i>
              </span>
              <span
                class="kt-menu__link-text text-slate-900"
                :style="`${
                  activeRoute( '/client/shops'
                  )
                    ? 'color: var(--navbar-text-active) !important'
                    : ''
                }`"
                >Secret Shop Home
              </span>
            </router-link>
          </v-hover>
        </li>
      </ul>
    </div>
  </div>
</template>
<!-- end:: Header Menu -->
<script>
import {
  find as lodashFind,
  filter as lodashFilter,
  isEmpty as lodashIsEmpty,
  map as lodashMap,
  some as lodashSome,
  findIndex as _findIndex,
  includes as _includes,
  some as _some,
} from 'lodash-es';

export default {
  name: 'HeaderMenu',
  props: ['topBarFontColor', 'hoverActiveColor'],
  computed: {
    isShopper() {
      return _some(this.$auth.user().roles, { name: 'secret-shopper' });
    },
    secondary() {
      return localStorage.secondaryColor
        ? localStorage.secondaryColor
        : '#181818';
    },
    routes() {
      const routes = lodashFind(this.$router.options.routes, { path: '/' });
      const user = this.$auth.user();

      const items = lodashFilter(
        routes.children,
        (item) => item.icon !== undefined
      );

      // Link to v1
      // const secretShopIndex = _findIndex(items, { name: 'Secret Shops' });
      const fileManagerIndex = _findIndex(items, { name: 'File Manager' });
      // items[secretShopIndex].path = '/clients/shops';
      items[fileManagerIndex].path = '/central/file-manager';

      return lodashFilter(items, (item) => {
        let include = true;
        if (lodashIsEmpty(item.meta)) {
          return true;
        }

        // eslint-disable-next-line consistent-return
        lodashMap(item.meta.permissions, (permission) => {
          if (
            lodashSome(user.role, { name: permission.role }) &&
            !permission.access
          ) {
            include = false;
            return false;
          }
        });

        return include;
      });
    },
  },
  methods: {
    goToRef() {
      window.open('/v3/lms', '_self');
    },
    activeRoute(path) {
      return path === this.$route.path;
    },

    isNewTab(path) {
      return _includes(['File Manager'], path) ? '_blank' : '';
    },

    toggleBrowseMenu() {
      this.$store.dispatch('app/toggleMenu');
    },

    hideTopMenu(path) {
      const roles = this.$auth.user().roles;

      if (path === 'Secret Shops') {
        return !this.$auth.user().dealer.secretshop_service;
      }

      return _includes(['Report'], path)
        ? _some(roles, { name: 'salesperson' })
          ? true
          : false
        : false;
    },
  },
  created() {
    if ('goToSection' in this.$route.query) {
      setTimeout(() => {
        window.open('/v3/lms', '_self');
      }, 1000);
    }
    // fix for v1 login
    const auth = this.$auth;
    document.cookie = `default_auth_token=${auth.token()};path=/`;
    document.cookie = `default_auth_user=${JSON.stringify(auth.user())};path=/`;
  },
  mounted() {},
};
</script>
<style lang="stylus">
.pulsing:hover,
.pulsing,
.pulsing-active {
  box-shadow: 0 0 0 0 rgba(0,0,0, 1);
  animation: pulse-black 1.2s infinite;
}
/* Animation */
@keyframes pulse-black {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0,0,0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0,0,0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}


#browseCourseLink
  position relative

#browseCourseLink:after
  content ''
  height 50%
  width 1px

  position absolute
  right 0
  top 25%

  background-color #000000
</style>
